import hasRole from './permission/hasRole'
import hasPermi from './permission/hasPermi'
import copyText from './common/copyText'
import draggable from './common/draggable'

export default {
  install(app) {
    app.directive('hasRole', hasRole)
    app.directive('hasPermi', hasPermi)
    app.directive('copyText', copyText)
    app.directive('draggable', draggable)
  }
}
